import React, {useContext} from 'react';
import Layout from '../Layout/Layout';
import PageHeader from '../PageHeader/PageHeader';
import Tile from '../Tile/Tile';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import {CompanyIcon,QuestionnaireIcon,ReportIcon,UploadIcon} from './tileIcons';
import {ProgressState} from '../../styles/commons';
import {ProgressesStatus} from '../../context';


const ProgressScreen = () => {
  const progress = useContext(ProgressesStatus);
  const text = {
    unavailable: 'UNAVAILABLE',
    disabled: 'UNAVAILABLE',
    notStarted: 'NOT STARTED',
    inProgress: 'IN PROGRESS',
    started: 'IN PROGRESS',
    completed: 'COMPLETED',
    available: 'AVAILABLE'
  }
  
  const companyLink = progress.company === 'unavailable' || progress.company === 'completed' ? '/progress' : '/company'
  const uploadLink = progress.uploadFiles === 'unavailable' ? '/progress' : '/upload'
  const questionnaireLink = progress.questionnaire === 'unavailable'  || progress.questionnaire === 'completed' ? '/progress' : '/questionnaire'
  const reportLink = progress.report === 'unavailable' ? '/progress' : '/report'

  const isUnavailable = progress.company === 'unavailable'
                      && progress.uploadFiles === 'unavaiable'
                      && progress.questionnaire === 'unavailable'
                      && progress.report === 'unavailable'

  return (
    <Layout product="ica">
      <PageHeader title='Progress' />
        { !isUnavailable && (<Container>
          <Row>
            <Col md={6} lg={4}>
              <Tile link={`${companyLink}`} title='Company'>
                <div style={{height:66}}><CompanyIcon width={130}/></div>
                <ProgressState progress={progress.company}>{text[progress.company]}</ProgressState>
              </Tile>
            </Col>
            <Col md={6} lg={4}>
              <Tile link={`${uploadLink}`} title='Upload'>
                <div style={{height:66}}><UploadIcon width={130}/></div>
                <ProgressState progress={progress.uploadFiles}>{text[progress.uploadFiles]}</ProgressState>
              </Tile>
            </Col>
            <Col md={6} lg={4}>
              <Tile link={`${questionnaireLink}`} title='Questionnaire'>
                <div style={{height:66}}><QuestionnaireIcon width={130}/></div>
                <ProgressState progress={progress.questionnaire}>{text[progress.questionnaire]}</ProgressState>
              </Tile>
            </Col>
            <Col md={6} lg={4}>
              <Tile link={`${reportLink}`} title='Reports'>
                <div style={{height:66}}><ReportIcon width={130}/></div>
                <ProgressState progress={progress.report}>{text[progress.report]}</ProgressState>
              </Tile>
            </Col>
          </Row>
        </Container>)}
    </Layout>
  );
};

export default ProgressScreen;
